// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"55764ea4","45":"4a1ad030","173":"1a4cb989","355":"e000c626"}[chunkId] + ".chunk.js";
};